export default __webpack_public_path__ + "static/media/Entertrainment.cc68cfb1.svg";